export default __webpack_public_path__ + "static/media/5.20.dcd47f21.mp3";